import { render, staticRenderFns } from "./ProjecaoList.vue?vue&type=template&id=04ef9a43&scoped=true"
import script from "./ProjecaoList.vue?vue&type=script&lang=js"
export * from "./ProjecaoList.vue?vue&type=script&lang=js"
import style0 from "./ProjecaoList.vue?vue&type=style&index=0&id=04ef9a43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef9a43",
  null
  
)

export default component.exports